import Card from "~/components/Card"
import Icon from "~/components/Icon"
import { IProjectIntro } from "~/types/recruiter"
import { Markdown } from "../Markdown"
import "./index.scss"

export default function ProjectInfoCard({
  title,
  subtitle,
  content,
  links
}: IProjectIntro) {
  return (
    <Card className="bg-primary-50 md:p-10" dataTestId="project-info-card">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <h1 className="text-2xl md:text-3xl font-bold text-primary-900 leading-tight">
            {title}
          </h1>
          <p className="text-neutral-600 text-base leading-relaxed">
            {subtitle}
          </p>
        </div>

        <div className="bg-primary-100 rounded-2xl p-5 md:p-6">
          <Markdown className="ProjectInfoCard__content">{content}</Markdown>
        </div>

        {links.map((link, index) => (
          <button
            key={link.href + link.label + index}
            type="button"
            className="flex items-center justify-between w-full bg-neutral-200 hover:bg-primary-200 rounded-xl px-5 py-4 transition-colors group"
            data-testid="read-more-button"
            onClick={() => window.open(link.href)}
          >
            <span className="text-neutral-600 text-sm font-medium">
              {link.label}
            </span>
            <Icon
              name="arrowRight"
              className="w-4 h-4 text-primary-500 group-hover:translate-x-1 transition-transform"
            />
          </button>
        ))}
      </div>
    </Card>
  )
}
